module.exports = __webpack_public_path__ + "static/img/man4.0c18a65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/HumanPic/man4.png
// module id = 4ACS
// module chunks = 2